import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AugmentedReality"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.25 22.4998C4.42192 22.4989 3.75083 21.8278 3.75 20.9998V2.99976C3.75083 2.17167 4.42192 1.50058 5.25 1.49976H15V2.99976H5.25V20.9998H15V17.9998H16.5V20.9998C16.4992 21.8278 15.8281 22.4989 15 22.4998H5.25ZM16.0852 4.57886L20.5853 6.82886C20.8395 6.95592 21.0001 7.21584 21 7.50011V12.7501C20.9998 13.0341 20.8393 13.2937 20.5853 13.4206L16.0852 15.6706C15.8742 15.776 15.6258 15.776 15.4148 15.6706L10.9148 13.4206C10.6607 13.2937 10.5002 13.0341 10.5 12.7501V7.50011C10.4999 7.21584 10.6605 6.95592 10.9148 6.82886L15.4148 4.57886C15.6258 4.47339 15.8742 4.47339 16.0852 4.57886ZM11.25 18.3748C11.25 18.9961 10.7463 19.4998 10.125 19.4998C9.50368 19.4998 9 18.9961 9 18.3748C9 17.7534 9.50368 17.2498 10.125 17.2498C10.7463 17.2498 11.25 17.7534 11.25 18.3748ZM18.5729 7.50012L15.7499 6.08862L12.9269 7.50012L15.7499 8.91162L18.5729 7.50012ZM12 8.71362L15 10.2136V13.7866L12 12.2866V8.71362ZM16.5 10.2136V13.7866L19.5 12.2866V8.71362L16.5 10.2136Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AugmentedReality.vue"]]);
